// extracted by mini-css-extract-plugin
export default {"regularText":"styles_regularText__0LqDF"};